import { render, staticRenderFns } from "./BudgetDetail.html?vue&type=template&id=4d81383d&scoped=true&"
import script from "./BudgetDetail.component.js?vue&type=script&lang=js&"
export * from "./BudgetDetail.component.js?vue&type=script&lang=js&"
import style0 from "./BudgetDetail.scss?vue&type=style&index=0&id=4d81383d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d81383d",
  null
  
)

export default component.exports